import React, { useEffect, useState, useRef } from "react";
import {
    Breadcrumb,
    Button,
    Space,
    Form,
    Input,
    Row,
    Col,
    Checkbox,
    Upload,
    Spin,
    Radio,
    Select,
    DatePicker,
    List,
    Comment,
    Image,
    Avatar,
    Tabs,
} from "antd";
import {
    EditOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from 'react-redux';
import { fetchEditHistory, documentEditHistorySelector, clearState, clearStateSendPdfForAppend, sendPdfForAppend } from './DocumentEditHistorySlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { Link, useLocation, useHistory } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { SyncOutlined } from '@ant-design/icons';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const recived = [
    {
        title: 'Recived item 1',
    }
];

function DocumentEditHistory() {

    const dispatch = useDispatch();
    let history = useHistory();
    const location = useLocation();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const { isFetching, iseditHistorySucess, isPdfFileSended, isError, errorMessage, editHistoryData } = useSelector(
        documentEditHistorySelector
    );
    const useThisRef = useRef(null);

    const [AllEditHistroyData, setDataSource] = useState([]);

    useEffect(() => {
        setLoading(true);
        dispatch(clearState());
        dispatch(fetchEditHistory(location.state.documentInfo.documentUpdatedData.processId));
    }, []);

    useEffect(() => {

        if (isError) {
            setLoading(false);
            // toast.error(errorMessage);
            if (iseditHistorySucess === false) { setDataSource([]); }
        }
        if (iseditHistorySucess) {
            setLoading(false);
            setDataSource(editHistoryData);
        }
        if (isPdfFileSended) {
            setLoading(false);
            toast.success(errorMessage);
            dispatch(clearStateSendPdfForAppend());
        }

    }, [isError, isPdfFileSended, iseditHistorySucess, setLoading, editHistoryData, setDataSource]);


    async function ConvertStringToHtml(str) {
        var parser = new DOMParser();
        var doc = await parser.parseFromString(str, 'text/html');
        // useThisRef.current.appendChild(doc.body);
        return await doc.body;
    }

    const handleAddDataIntoPdf = (e, values) => {
        // console.log(values)
        e.preventDefault();
        setLoading(true);
        const elemntData = document.getElementById(values.id);
        // var parser = new DOMParser();
        // var doc = parser.parseFromString(elemntData, 'text/html');


        // console.log("doc", doc.body);
        // // useThisRef.current.removeChild()
        // useThisRef.current.appendChild(doc.body);
        // var doc = new jsPDF()

        // doc.addPage();
        // doc.addImage(elemntData, "JPEG", 0, 0);
        // doc.output("dataurlnewwindow");


        html2canvas(elemntData).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            var width = pdf.internal.pageSize.getWidth() - 10;
            var height = pdf.internal.pageSize.getHeight() - 10;

            pdf.addImage(imgData, "PNG", 30, 20);
            pdf.text(values.title, 20, 10);

            // pdf.addImage(imgData, "PNG", 30, 20);
            // pdf.text(values.title, 20, 10);
            // var a = pdf.save("download.pdf");
            var blob = pdf.output("blob");
            // const data = {
            //     "processId": location.state.documentInfo.documentUpdatedData.processId,
            //     "editHistoryID": values.id,
            //     "pdfFile": pdf.save("download.pdf")
            // }
            // console.log("data=> ", data)
            var formData = new FormData();
            formData.append('pdfFile', blob);
            formData.append('processId', location.state.documentInfo.documentUpdatedData.processId);
            formData.append('editHistoryID', values.id);
            dispatch(sendPdfForAppend(formData)).then(res => {

                if (res.payload.message === "Edited pdf successfully updated") {
                    setLoading(false);
                    dispatch(fetchEditHistory(location.state.documentInfo.documentUpdatedData.processId));
                }
            });
        });


    }


    let dataSource = isLoading
        ? []
        : AllEditHistroyData ? AllEditHistroyData.map(row => ({
            id: row._id,
            title: row.title,
            message: row.message,
            messageInHtml: row.messageInHtml,
            appended: row.appended,
        })) : [];


    return (
        <>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
                <Toaster
                    toastOptions={{
                        className: '',
                        style: {
                            border: '1px solid #713200',
                            padding: '16px',
                            color: '#713200',
                            marginTop: 50
                        },
                    }}
                >
                    {(t) => (
                        <ToastBar toast={t}>
                            {({ icon, message }) => (
                                <>
                                    {icon}
                                    {message}
                                    {t.type !== 'loading' && (
                                        <button onClick={() => toast.dismiss(t.id)}>X</button>
                                    )}
                                </>
                            )}
                        </ToastBar>
                    )}
                </Toaster>
            }
            <List
                className="process-edit-history-tab"
                itemLayout="horizontal"
                dataSource={dataSource.reverse()}
                renderItem={item => (
                    // <List.Item className="process-edit-history" actions={[<Button style={{ borderColor: "#a1a1C1" }} type={'default'}>Added to pdf</Button>]}>
                    <List.Item className="process-edit-history" >
                        <List.Item.Meta
                            title={
                                <>
                                    <span className="edit-history-count">{item.title}</span>
                                    {item.appended === true ? <Button style={{ borderColor: "#a1a1C1" }} ghost type={'primary'}>Added into pdf</Button> : <Button onClick={(e) => handleAddDataIntoPdf(e, item)} className="processEditHistory-addToPdf-btn" style={{ border: 'solid 1px #cccccc' }} type={'default'}>Add to pdf</Button>}
                                </>
                            }
                            description={
                                <>
                                    <p className="edit-history-text" id={item.id} dangerouslySetInnerHTML={{ __html: item.messageInHtml }} ></p>
                                    {/* <div id={item.id} style={{ display: "none", width: "100%" }} dangerouslySetInnerHTML={{ __html: item.messageInHtml }} ></div> */}
                                </>
                            }
                        />
                    </List.Item>
                )}
            />
        </>
    )
}

export default DocumentEditHistory
